export default "/images/0f02673479a67889f4eb81206acbc708.avif";